import * as React from "react";
import Modal from "../../ui/modal/Modal";
import FormButtonsView from "../../ui/form/FormButtonsView";
import IndividualContact from "../../../model/contact/IndividualContact";
import TwillioDialer from "../../twillioVoice/TwillioDialer";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface IComponentProps {
	/**
	 * Close modal callback.
	 */
	onClose: () => void;
	/**
	 * Contact to call.
	 */
	contact: IndividualContact;
}

type Props = IComponentProps

export default class TwilioModal extends React.PureComponent<Props, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onClose}
				   title={`Call to: ${this.props.contact.data.displayName()}`}>
				<TwillioDialer contact={this.props.contact}/>
				<FormButtonsView align={"right"}>
					<div style={{paddingTop: "20px"}}>
						<div className="pull-left">
							<ButtonTertiary label="Cancel" onClick={this.props.onClose}/>
						</div>
					</div>
				</FormButtonsView>
			</Modal>
		)
	}
}